<script lang="ts">
  import { i18n } from "../i18n.svelte";
  import { inview } from "../actions";
  import Sprout from "./Sprout.svelte";

  const c = $derived(i18n.t.cta);
  let email = $state("");

  function submit(e: Event) {
    e.preventDefault();
    const subject = encodeURIComponent("Tane — early access");
    const body = encodeURIComponent(
      (i18n.locale === "ja"
        ? "アーリーアクセスに登録したいです。\nEmail: "
        : "I'd like to join Tane's early access.\nEmail: ") + email,
    );
    window.location.href = `mailto:${c.email}?subject=${subject}&body=${body}`;
  }
</script>

<section class="section cta" id="cta">
  <div class="container">
    <div class="box reveal" use:inview>
      <span class="seed"><Sprout size={56} stage={4} soil /></span>
      <p class="kicker">{c.label}</p>
      <h2>{c.title}</h2>
      <p class="lead">{c.lead}</p>

      <form class="form" onsubmit={submit}>
        <input
          type="email"
          required
          bind:value={email}
          placeholder={c.placeholder}
          aria-label={c.placeholder}
        />
        <button type="submit" class="btn btn-primary">
          {c.button}<span class="arrow">→</span>
        </button>
      </form>

      <p class="note">{c.note}</p>
    </div>
  </div>
</section>

<style>
  .cta {
    border-top: 1px solid var(--line);
  }
  .box {
    position: relative;
    max-width: 760px;
    margin-inline: auto;
    text-align: center;
    padding: clamp(2.5rem, 1.5rem + 4vw, 4.5rem) clamp(1.5rem, 1rem + 3vw, 4rem);
    background:
      radial-gradient(90% 90% at 50% 0%, rgba(95, 179, 100, 0.14), transparent 65%),
      var(--paper-card);
    border: 1px solid var(--line);
    border-radius: calc(var(--radius) * 1.6);
    box-shadow: var(--shadow);
    overflow: hidden;
  }
  .seed {
    display: inline-grid;
    place-items: center;
    width: 84px;
    height: 84px;
    border-radius: 50%;
    background: var(--sprout-soft);
    margin-bottom: 1.4rem;
  }
  .kicker {
    justify-content: center;
  }
  h2 {
    margin-top: 1rem;
    font-size: var(--fs-h2);
  }
  .lead {
    margin: 1.3rem auto 0;
    max-width: 52ch;
    font-size: var(--fs-lead);
    color: var(--ink-soft);
    line-height: 1.85;
  }

  .form {
    margin: 2.2rem auto 0;
    display: flex;
    gap: 0.6rem;
    max-width: 480px;
  }
  .form input {
    flex: 1;
    padding: 0.85em 1.2em;
    border-radius: 999px;
    border: 1px solid var(--line-strong);
    background: var(--paper);
    color: var(--ink);
    transition: border-color 0.3s var(--ease);
  }
  .form input:focus {
    outline: none;
    border-color: var(--green);
  }
  .form .btn {
    flex: none;
  }

  .note {
    margin-top: 1.6rem;
    font-size: 0.82rem;
    color: var(--muted);
  }

  @media (max-width: 540px) {
    .form {
      flex-direction: column;
    }
    .form .btn {
      justify-content: center;
    }
  }
</style>
